// Client → Server
export const C2S = {
  LOBBY_LIST: 'lobby:list',
  LOBBY_CREATE: 'lobby:create',
  LOBBY_JOIN: 'lobby:join',
  LOBBY_LEAVE: 'lobby:leave',
  GAME_START: 'game:start',
  ROUND_SUBMIT: 'round:submit',
  ROUND_READY: 'round:ready',
  ROUND_UNREADY: 'round:unready',
  GAME_REJOIN: 'game:rejoin',
  GAME_LEAVE_SCREEN: 'game:leaveScreen',
  GAME_REMATCH: 'game:rematch',
  PRESENCE_LIST: 'presence:list',
  PRESENCE_SET_STATUS: 'presence:setStatus',
  CHALLENGE_SEND: 'challenge:send',
  CHALLENGE_ACCEPT: 'challenge:accept',
  CHALLENGE_DECLINE: 'challenge:decline',
  EMOTE_SEND: 'emote:send',
  TOURNAMENT_STATE: 'tournament:state',
  TOURNAMENT_REGISTER: 'tournament:register',
  TOURNAMENT_UNREGISTER: 'tournament:unregister',
} as const;

// Server → Client
export const S2C = {
  USER_PROFILE: 'user:profile',
  LOBBY_ROOM_LIST: 'lobby:roomList',
  LOBBY_ROOM_UPDATED: 'lobby:roomUpdated',
  // Broadcast to all connected clients when a new room is created
  LOBBY_ROOM_CREATED: 'lobby:roomCreated',
  ROOM_STATE: 'room:state',
  ROOM_PLAYER_JOINED: 'room:playerJoined',
  ROOM_PLAYER_LEFT: 'room:playerLeft',
  ROOM_PLAYER_DISCONNECTED: 'room:playerDisconnected',
  ROOM_PLAYER_RECONNECTED: 'room:playerReconnected',
  GAME_STARTING: 'game:starting',
  ROUND_START: 'round:start',
  ROUND_LEADERBOARD_UPDATE: 'round:leaderboardUpdate',
  ROUND_END: 'round:end',
  ROUND_ALL_READY: 'round:allReady',
  GAME_END: 'game:end',
  REMATCH_INVITE: 'rematch:invite',
  ACHIEVEMENT_UNLOCKED: 'achievement:unlocked',
  PRESENCE_LIST: 'presence:list',
  PRESENCE_ONLINE: 'presence:online',
  PRESENCE_OFFLINE: 'presence:offline',
  CHALLENGE_RECEIVED: 'challenge:received',
  CHALLENGE_SENT: 'challenge:sent',
  CHALLENGE_ACCEPTED: 'challenge:accepted',
  CHALLENGE_DECLINED: 'challenge:declined',
  CHALLENGE_CANCELLED: 'challenge:cancelled',
  CHALLENGE_FAILED: 'challenge:failed',
  EMOTE_RECEIVED: 'emote:received',
  TOURNAMENT_STATE: 'tournament:state',
  TOURNAMENT_REMINDER: 'tournament:reminder',
  TOURNAMENT_STARTING: 'tournament:starting',
  TOURNAMENT_CANCELLED: 'tournament:cancelled',
  ERROR: 'error',
} as const;
